var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoadsideService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8301 13.1953V17.6893H21.3301V13.1953H22.8301Z",
    fill: "#6F757C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.4009 23.4707C20.871 23.4707 19.6309 24.7109 19.6309 26.2407C19.6309 27.7705 20.871 29.0107 22.4009 29.0107C23.9307 29.0107 25.1709 27.7705 25.1709 26.2407C25.1709 24.7109 23.9307 23.4707 22.4009 23.4707ZM18.1309 26.2407C18.1309 23.8824 20.0426 21.9707 22.4009 21.9707C24.7591 21.9707 26.6709 23.8824 26.6709 26.2407C26.6709 28.599 24.7591 30.5107 22.4009 30.5107C20.0426 30.5107 18.1309 28.599 18.1309 26.2407Z",
    fill: "#6F757C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0098 6.3993C17.0098 5.36708 17.8476 4.5293 18.8798 4.5293C19.3769 4.5293 19.8516 4.7265 20.2021 5.07697C20.5526 5.42743 20.7498 5.90212 20.7498 6.3993V8.4293H17.0098V6.3993ZM18.8798 6.0293C18.676 6.0293 18.5098 6.19551 18.5098 6.3993V6.9293H19.2498V6.3993C19.2498 6.30047 19.211 6.20716 19.1414 6.13763C19.0719 6.06809 18.9786 6.0293 18.8798 6.0293Z",
    fill: "#6F757C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5137 6.92969H24.211L25.9607 16.1682L27.1096 16.798C27.9216 17.243 28.8979 17.7779 29.5556 18.1377C30.2592 18.5219 30.6937 19.2588 30.6937 20.0577V27.2077H25.6797V25.7077H29.1937V20.0577C29.1937 19.8049 29.0565 19.5741 28.8365 19.4541C28.1783 19.094 27.2007 18.5584 26.3887 18.1134L24.9296 17.3136L24.6187 17.1431L22.9684 8.42969H16.0137V16.0317H14.5137V6.92969Z",
    fill: "#6F757C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5137 16.0312H16.0137V25.7073H19.1997V27.2073H14.5137V16.0312Z",
    fill: "#6F757C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0391 27.207H-0.960938V25.707H15.0391V27.207Z",
    fill: "#6F757C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-0.480469 22.2891H15.3595V23.7891H-0.480469V22.2891Z",
    fill: "#6F757C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.98242 16.848L9.57671 15.4707L9.75963 15.5494C9.87037 15.5969 10.019 15.6605 10.1708 15.725L10.1719 15.7255C10.5298 15.8782 10.9137 15.9573 11.3016 15.9573H12.2851L12.2856 17.4573H11.3016C10.7096 17.4573 10.1257 17.3365 9.58378 17.1054C9.42982 17.04 9.27963 16.9757 9.168 16.9278L8.98242 16.848Z",
    fill: "#6F757C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.43619 13.2969H-10.7578V11.7969H4.43619V13.2969Z",
    fill: "#6F757C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-8.47312 9.91645C-7.77587 9.2192 -6.83068 8.82812 -5.84545 8.82812H-0.0454531C0.55819 8.82812 1.12493 9.12329 1.47038 9.6166C1.93429 10.2785 2.52222 11.1179 2.99421 11.7918L3.82213 12.9742L3.99101 13.2155L4.27939 13.2775L9.4311 14.3854C10.7714 14.6732 11.7305 15.8596 11.7305 17.2321V18.9092L6.81664 18.9164C6.89823 19.1484 6.94261 19.3979 6.94261 19.6578C6.94261 19.9242 6.89601 20.1796 6.81051 20.4164L13.2305 20.407V17.2321C13.2305 15.1528 11.7776 13.3552 9.74599 12.9188L4.88206 11.8728L4.22289 10.9314C3.75087 10.2574 3.1628 9.41779 2.69871 8.75565C2.07215 7.86111 1.0468 7.32812 -0.0454531 7.32812H-5.84545C-7.22808 7.32812 -8.55475 7.87693 -9.53347 8.85548C-10.4288 9.74884 -10.9641 10.9346 -11.0494 12.1892L-11.465 12.5459C-11.8537 12.8793 -12.3543 13.3085 -12.8029 13.6921L-12.8045 13.6935C-13.6839 14.4498 -14.1895 15.5493 -14.1895 16.7101V19.6961H-13.4395L-13.4384 20.4461L2.60894 20.4226C2.52202 20.184 2.47461 19.9265 2.47461 19.6578C2.47461 19.4003 2.5182 19.1529 2.59841 18.9226L-12.6895 18.945V16.7101C-12.6895 15.9873 -12.3753 15.3031 -11.8272 14.8314C-11.3779 14.4472 -10.877 14.0178 -10.4884 13.6844L-9.82277 13.1131L-9.56145 12.8886V12.5441C-9.56145 11.5566 -9.16953 10.6112 -8.47312 9.91645Z",
    fill: "#6F757C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.70861 18.1738C3.88902 18.1738 3.22461 18.8382 3.22461 19.6578C3.22461 20.4774 3.88902 21.1418 4.70861 21.1418C5.5282 21.1418 6.19261 20.4774 6.19261 19.6578C6.19261 18.8382 5.5282 18.1738 4.70861 18.1738ZM1.72461 19.6578C1.72461 18.0098 3.06059 16.6738 4.70861 16.6738C6.35663 16.6738 7.69261 18.0098 7.69261 19.6578C7.69261 21.3058 6.35663 22.6418 4.70861 22.6418C3.06059 22.6418 1.72461 21.3058 1.72461 19.6578Z",
    fill: "#6F757C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0794 16.9043H15.3594V15.4043H22.0794V16.9043Z",
    fill: "#6F757C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadsideService);
export default __webpack_public_path__ + "static/media/roadside-service.d033c0541301147aaffba4451e58cc17.svg";
export { ForwardRef as ReactComponent };